import type {
  InteractionStatus,
  Referral,
  ReferralSummary,
} from '@/common/hooks/referrals/types';
import {
  AgreementStatus,
  TransactionStatusMissing,
} from '@/common/hooks/referrals/types';
import { CreateInteractionButtonRenderer } from '@/views/Referrals/components/TransactionStatus/CreateInteractionButtonRenderer';

export const statusLabels: Record<InteractionStatus, string> = {
  missing: 'Not Added Yet',
  external: 'Contact Agent',
  acceptancePending: 'Acceptance Pending',
  accepted: 'Accepted',
  accepting: 'Accepting',
  active: 'Active',
  activeCont: 'Active Contingent',
  backUp: 'Back Up',
  buyerCountered: 'Buyer Countered',
  cancellationPending: 'Cancelation Pending',
  cancelled: 'Canceled',
  closed: 'Closed',
  comingSoon: 'Coming Soon',
  counterOfferSent: 'Counter Offer Sent',
  countering: 'Countering',
  expired: 'Expired',
  handshake: 'Handshake',
  lost: 'Lost',
  noStatus: 'No Status',
  onMarket: 'On Market',
  offMarket: 'Off Market',
  pending: 'Pending',
  preListing: 'Pre-Listing',
  ratified: 'Ratified',
  rejected: 'Rejected',
  sellerCountered: 'Seller Countered',
  underReview: 'Under Review',
  withdrawn: 'Withdrawn',
};

export function getTransactionStatusContent({
  isTransactingAgent,
  referral,
}: {
  isTransactingAgent: boolean;
  referral:
    | Pick<
        ReferralSummary,
        'transactionStatus' | 'agreementStatus' | 'id' | 'client'
      >
    | Pick<Referral, 'transactionStatus' | 'agreementStatus' | 'id' | 'client'>;
}) {
  const { agreementStatus, transactionStatus, id, client } = referral;

  if (
    !isTransactingAgent ||
    agreementStatus !== AgreementStatus.Completed ||
    transactionStatus !== TransactionStatusMissing ||
    !client?.clientTypesList?.length
  ) {
    return statusLabels[transactionStatus];
  }

  return (
    <CreateInteractionButtonRenderer
      clientTypes={client.clientTypes}
      clientTypesList={client.clientTypesList}
      referralId={id}
    />
  );
}
